import { HELP_CENTRE_URL } from '../../../../AppConstants';

export const SWIMBOOKER_PLUS_SIGN_UP_URL = `${process.env.REACT_APP_SBPLUS_URL}/sign-up`;

const anglerAccountLinks = (isLoggedIn) =>
  isLoggedIn
    ? [
        { label: 'My Profile', to: '/user/profile' },
        { label: 'Log Out', action: 'logOut' },
      ]
    : [{ label: 'Angler Login', to: '/join' }];

export const getSiteNavigation = (isLoggedIn) => [
  {
    title: 'For Anglers',
    links: [
      { label: 'Find Lakes', to: '/search' },
      ...anglerAccountLinks(isLoggedIn),
      { label: 'swimbooker+', href: SWIMBOOKER_PLUS_SIGN_UP_URL },
      { label: 'Submit Catch Report', action: 'catchReport' },
      { label: 'Angling Social', to: '/articles' },
      { label: 'Book Your Crossing', action: 'crossing' },
    ],
  },
  {
    title: 'For Fisheries',
    links: [
      { label: 'Fishery Login', to: '/admin/login' },
      { label: 'List Your Lakes With Us', to: '/swimbooker-fishery-manager' },
      { label: 'Pricing', to: '/swimbooker-fishery-manager#offer' },
      {
        label: 'Testimonials',
        to: '/swimbooker-fishery-manager#testimonials',
      },
    ],
  },
  {
    title: 'About',
    links: [
      { label: 'Help', href: HELP_CENTRE_URL },
      { label: 'Contact Us', to: '/contact' },
      { label: 'About Us', to: '/about' },
      { label: 'News', to: '/articles' },
      { label: 'Brand Partners', to: '/brands' },
    ],
  },
];
